export default (payload) => ({
  type: 'CLEAR_NOTI',
  payload,
});
